"use strict";

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var GlobalConfigDTO = function GlobalConfigDTO() {
  _classCallCheck(this, GlobalConfigDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], GlobalConfigDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], GlobalConfigDTO.prototype, "limitSimulationVisitor", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], GlobalConfigDTO.prototype, "limitSimulationMember", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], GlobalConfigDTO.prototype, "searchSeoText", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], GlobalConfigDTO.prototype, "homeSeoFooterText", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], GlobalConfigDTO.prototype, "homeSeoFooterLinks", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], GlobalConfigDTO.prototype, "searchSeoFooterText", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], GlobalConfigDTO.prototype, "searchSeoFooterLinks", void 0);

exports.GlobalConfigDTO = GlobalConfigDTO;

var GlobalConfigUpdateDTO = function GlobalConfigUpdateDTO() {
  _classCallCheck(this, GlobalConfigUpdateDTO);
};

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], GlobalConfigUpdateDTO.prototype, "limitSimulationVisitor", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], GlobalConfigUpdateDTO.prototype, "limitSimulationMember", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], GlobalConfigUpdateDTO.prototype, "searchSeoText", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], GlobalConfigUpdateDTO.prototype, "homeSeoFooterText", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], GlobalConfigUpdateDTO.prototype, "homeSeoFooterLinks", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], GlobalConfigUpdateDTO.prototype, "searchSeoFooterText", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], GlobalConfigUpdateDTO.prototype, "searchSeoFooterLinks", void 0);

exports.GlobalConfigUpdateDTO = GlobalConfigUpdateDTO;